import { render, staticRenderFns } from "./AdCarousel.vue?vue&type=template&id=2d36aff6&scoped=true"
import script from "./AdCarousel.vue?vue&type=script&lang=js"
export * from "./AdCarousel.vue?vue&type=script&lang=js"
import style0 from "./AdCarousel.vue?vue&type=style&index=0&id=2d36aff6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36aff6",
  null
  
)

export default component.exports